import React, { useState, useEffect } from 'react';
// import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import CurrencyFlag from 'react-currency-flags';

import * as currencySet from '../data/currency.json';
import { PLACEHOLDER_FIELD_CURRENCY } from '../placeholderHelper';
import AfitdAutocompleteLite from './AfitdAutocompleteLite';
import AfitdTypography from './AfitdTypography';
// import AfitdTextField from './AfitdTextField';

// import { withStyles } from '@material-ui/core/styles';
// import cx from 'clsx';
import _find from 'lodash/find';
import _remove from 'lodash/remove';
// const styles = theme => ({
// });

const currencyLov = Object.keys(currencySet.default).map(key => currencySet.default[key]);

const getOptionLabel = option => {
    const selectedOption = typeof option === 'string' ? _find(currencyLov, o => o.code === option) : option;
    // return selectedOption?.symbol_native && `${selectedOption.symbol_native} - ${selectedOption.code}`;
    return `${selectedOption.code} (${selectedOption.name})`;
};

const renderOption = (option, { selected }) => {
    return (
        <div style={{ display: 'flex' }}>
            <div style={{ marginRight: '5px' }}>
                <CurrencyFlag currency={option.code || 'USD'} width={30} />
            </div>
            <AfitdTypography style={{ marginRight: '5px' }}>{option.code}</AfitdTypography>
            <AfitdTypography variant="body2">{option.name}</AfitdTypography>
        </div>
    );
};

const getOptionSelected = (option, value) => {
    return typeof value === 'string' ? option.code === value : option.code === value?.code2;
};

const AfitdCurrencyAutocomplete = props => {
    const { countryCurrency = 'USD', ...otherProps } = props;
    const [options, setOptions] = useState(currencyLov);

    // sort the currency LOV (USD, CAD, EUR first)
    //   if user selected a country, set the corresponding currency at the top
    useEffect(() => {
        const sortedOptions = [...currencyLov];
        const optionCountryCurrency = _remove(sortedOptions, o => o.code === countryCurrency);
        const optionUSD = _remove(sortedOptions, o => o.code === 'USD');
        const optionCAD = _remove(sortedOptions, o => o.code === 'CAD');
        const optionEUR = _remove(sortedOptions, o => o.code === 'EUR');

        setOptions([...optionCountryCurrency, ...optionUSD, ...optionCAD, ...optionEUR, ...sortedOptions]);
    }, [countryCurrency]);

    return (
        <AfitdAutocompleteLite
            placeholder={PLACEHOLDER_FIELD_CURRENCY}
            {...otherProps}
            options={options}
            getOptionLabel={getOptionLabel}
            renderOption={renderOption}
            getOptionSelected={getOptionSelected}
        />
    );
};

export default AfitdCurrencyAutocomplete;
// export default withStyles(styles)(AfitdCurrencyAutocomplete);
